/**
 * Header section of editor page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import history from '../history'
import { Tooltip, DropdownLayout, Modal } from 'wix-style-react'
import * as _ from 'lodash'

import Text from 'components/common/Text'
import Link from 'components/common/Link'
import PublishButton from './editorHeader/PublishButton'
import PreviewButton from './editorHeader/PreviewButton'
import BackButton from './editorHeader/BackButton'
import SettingsView from './SettingsView'
import { media, HELVETICA, DARK_GRAY, LIGHTEST_GRAY } from 'components/styles'
import { publish } from 'controllers/logic'
import * as integrationType from 'constants/integrationType'
import { getTemplateInfo } from 'templates/templates'
import * as templateCategory from 'constants/templateCategory'
import * as editorModes from 'constants/editorMode'
import Logo from 'components/Logo'

const Wrapper = styled.div`
  ${media.small`height: 75px; font-size: 20px;`}
  ${media.huge`height: 75px; font-size: 26px;`}

  background: #fff;
  border-bottom: 1px solid ${LIGHTEST_GRAY};
`
const Container = styled.div`
  height: 100%;
  width: 100%;
  box-shadow: 0 1px 5px 0 rgba(41,85,115,0.21);

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  overflow: hidden;
  background-color: #fff;
`
const Menu = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
`
const RightButtons = styled.div`
  _padding-right: 30px;

  display: flex;
  flex-direction: row;
  align-items: center;

  & button {
    margin-left: 20px;
  }
`
const LeftNav = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
`
const MenuContainer = styled.div`
  width: 190px;
  height: ${props => props.isShort ? '220' : '250'}px;
  padding: 0.2em 0 0 0;
  text-align: left;

  & div {
    box-shadow: none;
    border-radius: 0;
  }
`
const NavigationItem = styled.div`
  ${HELVETICA}
  font-weight: 200;
  font-size: 95%;
  color: ${DARK_GRAY};
  padding: 0 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: #bbb;
  }
`
const OptionContainer = styled.div`
  padding-left: 10px;
`
const CenterContainer = styled.div`
  flex: 1;
  margin-right: 4em;
`

class EditorHeader extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isModalOpen: false,
      modalActiveTab: 1,
    }
    this.makeOptions(props)
  }

  componentWillReceiveProps (nextProps) {
    this.makeOptions(nextProps)
  }

  makeOptions (props) {
    const { app } = props
    const integration = _.get(app, 'customFields.appSettings.integration', null)
    this.options = [
      {id: 3, value: <OptionContainer>Connect Domain</OptionContainer>},
      {id: 4, value: <OptionContainer>App Title</OptionContainer>},
      {id: 5, value: <OptionContainer>Favicon</OptionContainer>},
      {id: 9, value: <OptionContainer>Desktop Redirect</OptionContainer>}
      // {id: 6, value: <OptionContainer>Analytics Integration</OptionContainer>}
    ]
    if (!_.isNil(integration)) {
      switch (integration.type) {
        case integrationType.SHOPIFY:
          this.options.push({id: 7, value: <OptionContainer>Shopify Integration</OptionContainer>})
          break
      }
    }
    this.options.push({id: 8, value: <OptionContainer>Exit Editor</OptionContainer>})
  }


  settingsMenu = (onSelect) => (
    <MenuContainer isShort={this.options.length === 6}>
      <DropdownLayout
        visible
        options={this.options}
        maxHeightPixels={400}
        onSelect={onSelect}
      />
    </MenuContainer>
  )

  settingsMenuItemSelected = (item) => {
    console.log('settingsMenuItemSelected', item)

    if (item.id === 8) { // Exit Editor
      this.goToDashboard()
    }

    const modalActiveTab = item.id === 7 ? 2 : 1
    this.setState({
      isModalOpen: true,
      modalActiveTab: modalActiveTab
    })
  }

  goToDashboard () {
    history.push('/dashboard/myApps')
  }

  closeModal = () => {
    this.setState({isModalOpen: false})
  }

  renderModal () {
    const { app } = this.props
    return (
      <Modal
        isOpen={this.state.isModalOpen}
        contentLabel=''
      >
        <SettingsView
          close={this.closeModal}
          modalActiveTab={this.state.modalActiveTab}
          app={app}
        />
      </Modal>
    )
  }

  onPublish = () => {
    const { dispatch, app } = this.props
    dispatch(publish(app))
  }

  onPreview = () => {
    const { onChangeEditorMode } = this.props
    onChangeEditorMode(editorModes.PREVIEW)
  }

  onEdit = () => {
    const { onChangeEditorMode } = this.props
    onChangeEditorMode(editorModes.EDIT)
  }

  renderRightButtons () {
    const { app, editorMode } = this.props
    const templateInfo = getTemplateInfo(app.templateId)
    if (templateInfo.category !== templateCategory.INSTAGRAM_SHOPPABLE) {
      if (editorMode === editorModes.EDIT) {
        return (
          <RightButtons>
            <PreviewButton onClick={this.onPreview} />
            <PublishButton onClick={this.onPublish} />
          </RightButtons>
        )
      } else {
        return (
          <RightButtons>
            <BackButton onClick={this.onEdit} />
          </RightButtons>
        )
      }
    } else {
      return null
    }
  }

  renderMenu () {
    const { editorMode } = this.props
    if (editorMode === editorModes.EDIT) {
      return (
        <Menu>
          <Tooltip
            hideDelay={1000}
            content={this.settingsMenu(this.settingsMenuItemSelected)}
            showTrigger='mouseenter'
            onClickOutside={null}
            onShow={null}
            placement='bottom'
            shouldCloseOnClickOutside
            moveBy={{x: 0, y: 15}}
          >
            <NavigationItem><Text size='default'>Settings</Text></NavigationItem>
          </Tooltip>
          <NavigationItem>
            <Link
              url='http://help.whimm.co/en'
              external
            >
              <Text>Help</Text>
            </Link>
          </NavigationItem>
        </Menu>
      )
    }
  }

  renderCenter () {
    const { editorMode } = this.props
    if (editorMode === editorModes.PREVIEW) {
      return (
        <CenterContainer>
          <Text>You are currently in preview mode</Text>
        </CenterContainer>
      )
    }
  }

  render () {
    return (
      <Wrapper>
        <Container>
          <LeftNav>
            <Logo onClick={this.goToDashboard} />
            {this.renderMenu()}
          </LeftNav>
          {this.renderCenter()}
          {this.renderRightButtons()}
          {this.renderModal()}
        </Container>
      </Wrapper>
    )
  }
}

EditorHeader.propTypes = {
  app: PropTypes.object.isRequired,
  onChangeEditorMode: PropTypes.func,
  editorMode: PropTypes.string
}

export default connect()(EditorHeader)



// WEBPACK FOOTER //
// ./src/components/editor/EditorHeader.js